module.exports = __webpack_public_path__ + "media/images/icons/check-0fc587b60d175f73ce2ad7f9f5f45aeb.svg";